import { render, staticRenderFns } from "./SkeletonLoaderReturnOptions.vue?vue&type=template&id=0953b3f2&scoped=true"
var script = {}
import style0 from "./SkeletonLoaderReturnOptions.vue?vue&type=style&index=0&id=0953b3f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0953b3f2",
  null
  
)

export default component.exports